import { Button, Table } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import MiniTable from '../../../../components/mini-table';
import useFormatter from '../../../../hooks/useFormatter';
import { compareNumbers } from '../../../../util/number';
import { compareStrings } from '../../../../util/string';
import TableCellEllipsis from '../../../../components/table-cell-ellipsis';

export default function EmpresaSociosTable9({ dataSource, loading, miniTableRef, onClick, onSelectedIdsChange, selectedIds, title }) {
  const { t } = useTranslation();
  const { formatCurrency, formatNumber, formatPercentage } = useFormatter();

  const fireClick = (socio) => (typeof onClick === 'function' ? onClick(socio) : undefined);

  function formatCNPJ(cnpj) {
    if (!cnpj) return '';
    const digits = cnpj.replace(/\D/g, '');
    return digits.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
  }

  const columns = [
    {
      title: t('CNPJ'),
      dataIndex: 'documento',
      key: 'documento',
      sorter: (a, b) => compareStrings(a.cnpj, b.cnpj),
      render: (text) => <TableCellEllipsis text={text ? formatCNPJ(text) : t('(não preenchido)')} />,
    },

    {
      title: t('Nome'),
      dataIndex: 'nome',
      key: 'nome',
      sorter: (a, b) => compareStrings(a.nome, b.nome),
      render: (text, record) => (
        <Button type="link" onClick={() => fireClick(record)}>
          {text ?? t('(não preenchido)')}
        </Button>
      ),
    },
    {
      title: t('Participação (%)'),
      align: 'right',
      dataIndex: 'participacao',
      key: 'participacao',
      width: 140,
      sorter: (a, b) => compareNumbers(a.capitalValorTotalPercentual, b.capitalValorTotalPercentual),
      render: (text, record) => formatPercentage(record.participacao, { minimumFractionDigits: 4, maximumFractionDigits: 4 }),
    },
    {
      title: t('Observação'),
      dataIndex: 'obs',
      key: 'obs',
      sorter: (a, b) => compareStrings(a.obs, b.obs),
      render: (text) => <TableCellEllipsis text={text} />,
    },
  ];

  return (
    <MiniTable
      ref={miniTableRef}
      columns={columns}
      dataSource={dataSource}
      loading={loading}
      title={title}
      rowSelection={{
        selectedRowKeys: selectedIds,
        onChange: onSelectedIdsChange,
      }}
      scroll={{
        y: 'auto'
      }}
    />
  );
}

EmpresaSociosTable9.propTypes = {
  dataSource: PropTypes.array,
  loading: PropTypes.bool,
  miniTableRef: PropTypes.object,
  onClick: PropTypes.func,
  onSelectedIdsChange: PropTypes.func,
  selectedIds: PropTypes.arrayOf(PropTypes.number),
  title: PropTypes.func,
};

